import React, { useState, useEffect } from 'react';
import { useImmer } from "use-immer";
import { Button, Modal, Form } from 'react-bootstrap';
import _ from 'lodash';
import moment from 'moment';
import { faUndo, faRedo } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BulkEditEventsModal = (props) => {

    const [refData, setRefData] = useState({
        statusRefData: [],
        assignedToRefData: [],
        queueRefData: [],
        customerRefData: [],
        eventPriorityRefData: [],
        caseOriginsRefData: [],
        lineOfBusinessRefData: [],
        requestedServiceRefData: []
    });
    const [editEvents, setEditEvents] = useImmer([[]]);
    const [editIndex, setEditIndex] = useState(0);
    const [editHistory, setEditHistory] = useImmer([]);

    //const [editEvents, setEditEvents] = useState([...props.refData]);

    useEffect(() => {
        //if (props.refData?.keys().length > 0) {
        //    setRefData(props.refData);
        //}
        setRefData(props.refData);
    }, [props.refData]);

    useEffect(() => {
        setEditEvents([props.editEvents]);
        setEditIndex(0);
    }, [props.editEvents]);

    const editSelectedEvent = (index, propName, propValue) => {
        setEditEvents(draft => {
            var newEdit = _.cloneDeep(draft[editIndex]);

            // modify the property on the event that was changed
            newEdit[index][propName] = propValue;
            if (propName == 'serviceRequestId') {
                newEdit[index].dueBy = null;
            }

            // if the edit index is not at the end
            if (editIndex < draft.length - 1) {
                // splice off the ones at the end
                draft.splice(editIndex + 1);
            }

            draft.push(newEdit);

            setEditIndex(draft.length - 1);
        });
    }

    const editSelectedEvents = (propName, propValue, displayPropName, displayPropValue) => {
        setEditEvents(draft => {
            var newEdit = _.cloneDeep(draft[editIndex]);

            // modify the property on each event that was changed
            newEdit.forEach((event, i) => {
                event[propName] = propValue;
                event[displayPropName] = displayPropValue;
                if (propName == 'serviceRequestId') {
                    event.dueBy = null;
                }
            });

            // if the edit index is not at the end
            if (editIndex < draft.length - 1) {
                // splice off the ones at the end
                draft.splice(editIndex + 1);
            }


            draft.push(newEdit);

            setEditIndex(draft.length - 1);
        });
        //setEditEvents(draft => {
        //    draft.forEach((event, i) => {
        //        event[propName] = propValue;
        //        event[displayPropName] = displayPropValue;
        //        if (propName == 'requestedServiceId') {
        //            event.dueBy = null;
        //        }
        //    });
        //});
        //const selectedEvents = [...this.props.selectedEvents];
        //selectedEvents.forEach((event, i) => {
        //    event[propName] = propValue
        //    event[displayPropName] = displayPropValue
        //})
        //props.updateSelectedEvents(selectedEvents);
    }

    const undo = () => {
        if (editIndex > 0) {
            setEditIndex(draft => draft -= 1);
        }
    }

    const redo = () => {
        if (editIndex < editEvents.length - 1) {
            setEditIndex(draft => draft += 1);
        }
    }

    const closeModal = () => {
        props.hideModal();
    }

    const saveEvents = async () => {
        var result = await props.updateSelectedEvents(editEvents[editIndex]);
        if (result) {
            closeModal();
        } else {
            alert("ERROR!");
        }
    }

    return (
        <>
            <Modal.Header className="d-flex align-items-center">
                <div className="mr-auto">Edit Events</div>
                <div className="card-btn-group">
                    <Button variant="secondary" size="sm" disabled={editIndex === 0} onClick={undo}>
                        <FontAwesomeIcon icon={faUndo} />
                    </Button>
                    <Button variant="secondary" size="sm" disabled={editIndex === editEvents.length - 1} onClick={redo}>
                        <FontAwesomeIcon icon={faRedo} />
                    </Button>
                </div>
            </Modal.Header>
            <Modal.Body className="modal-body-table">
                <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Description</th>
                            <th>
                                <Form.Control as="select"
                                    className="borderless-control"
                                    name="accountId" id="accountId"
                                    size="sm"
                                    onChange={(e) => editSelectedEvents("accountId", parseInt(e.target.value),
                                        "customerAccountName", e.target.selectedOptions[0].text)
                                    }>
                                    {
                                        refData.customerRefData.map((cust) => {
                                            return <option key={cust.id} value={cust.id}>{props.filters.accountId === cust.id ? "Customer: " + cust.name + ' (' + cust.id + ')' : cust.name + ' (' + cust.id + ')'}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>
                                <Form.Control as="select"
                                    value={props.filters.requestedServiceId}
                                    className="borderless-control"
                                    name="serviceRequestId" id="serviceRequestId"
                                    size="sm"
                                    onChange={(e) => editSelectedEvents("serviceRequestId", parseInt(e.target.value),
                                        "serviceRequestName", e.target.selectedOptions[0].text)}>
                                    {
                                        refData.requestedServiceRefData.map((service) => {
                                            return <option key={service.id} value={service.id}>{props.filters.requestedServiceId === service.id ? "Service: " + service.name : service.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>
                                <Form.Control as="select"
                                    className="borderless-control"
                                    name="lineOfBusinessId" id="lineOfBusinessId"
                                    size="sm"
                                    onChange={(e) => editSelectedEvents("lineOfBusinessId", parseInt(e.target.value),
                                        "lineOfBusinessName", e.target.selectedOptions[0].text)}>
                                    {
                                        refData.lineOfBusinessRefData.map((lob) => {
                                            return <option key={lob.id} value={lob.id}>{lob.name}</option>;
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th className={props.filters.showTeamQueue ? "d-none" : ""}>
                                <Form.Control as="select"
                                    className="borderless-control"
                                    name="queueId" id="queueId"
                                    size="sm"
                                    onChange={(e) => editSelectedEvents("codingEventQueueId", parseInt(e.target.value),
                                        "codingEventQueueName", e.target.selectedOptions[0].text)}>
                                    <option value={0}>Queues</option>
                                    {
                                        refData.queueRefData.filter(queue => queue.id !== 0).map((queue) => {
                                            return <option key={queue.id} value={queue.id}>{queue.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>
                                <Form.Control as="select"
                                    className="borderless-control"
                                    name="eventPriorityId"
                                    id="eventPriorityId"
                                    size="sm"
                                    onChange={(e) => editSelectedEvents("eventPriorityId", parseInt(e.target.value),
                                        "eventPriorityName", e.target.selectedOptions[0].text)}>
                                    {
                                        refData.eventPriorityRefData.map((priority) => {
                                            return <option key={priority.id} value={priority.id}>{priority.name}</option>
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th>Due By</th>
                            <th>
                                <Form.Control as="select"
                                    className="borderless-control"
                                    name="assignedToId"
                                    id="assignedToId"
                                    size="sm"
                                    onChange={(e) => editSelectedEvents("assignedToId",
                                        parseInt(e.target.value), "assignedToName", e.target.selectedOptions[0].text)}>
                                    <option value={0}>Assigned</option>
                                    {
                                        refData.assignedToRefData.filter(user => user.id !== 0).map((user) => {
                                            return <option key={user.id} value={user.id}>{user.name}</option>;
                                        })
                                    }
                                </Form.Control>
                            </th>
                            <th className="no-padding-td">Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            editEvents[editIndex].map((event, i) =>
                                <tr key={event.id}>
                                    <td>{event.id}</td>
                                    <td style={{ width: "300px" }}>{event.description.length > 80 ? event.description.substring(0, 80) + ' ...' : event.description}</td>
                                    <td className={props.filters.showCustomerQueue ? "d-none" : ""}>
                                        <Form.Control as="select"
                                            value={event.accountId}
                                            className="borderless-control"
                                            key={i}
                                            id={"accountId" + i}
                                            name="accountId"
                                            size="sm"
                                            onChange={(e) => editSelectedEvent(i, "accountId", parseInt(e.target.value))}>
                                            {
                                                refData.customerRefData.map((cust) => {
                                                    return cust.id > 0 ? <option key={cust.id} value={cust.id}>{cust.name + ' (' + cust.id + ')'}</option> : null;
                                                })
                                            }
                                        </Form.Control>
                                    </td>
                                    <td>
                                        <Form.Control as="select"
                                            value={event.serviceRequestId}
                                            className="borderless-control"
                                            name="serviceRequestId"
                                            key={i}
                                            id={"serviceRequestId" + i}
                                            size="sm"
                                            onChange={(e) => editSelectedEvent(i, "serviceRequestId", parseInt(e.target.value))}>
                                            {
                                                refData.requestedServiceRefData.map((service) => {
                                                    return service.id > 0 ? <option key={service.id} value={service.id}>{service.name}</option> : null;
                                                })
                                            }
                                        </Form.Control>
                                    </td>
                                    <td>
                                        <Form.Control as="select" value={event.lineOfBusinessId}
                                            className="borderless-control"
                                            name="lineOfBusinessId"
                                            key={i}
                                            id={"lineOfBusinessId" + i}
                                            size="sm"
                                            onChange={(e) => editSelectedEvent(i, "lineOfBusinessId", parseInt(e.target.value))}>
                                            {
                                                refData.lineOfBusinessRefData.map((lob) => {
                                                    return lob.id > 0 ? <option key={lob.id} value={lob.id}>{lob.name}</option> : null;
                                                })
                                            }
                                        </Form.Control>
                                    </td>
                                    <td className={props.filters.showTeamQueue ? "d-none" : ""}>
                                        <Form.Control as="select"
                                            value={event.codingEventQueueId}
                                            className="borderless-control"
                                            name="queueId"
                                            key={i}
                                            id={"queueId" + i}
                                            size="sm"
                                            onChange={(e) => editSelectedEvent(i, "codingEventQueueId", parseInt(e.target.value))}>
                                            {
                                                refData.queueRefData.map((queue) => {
                                                    return queue.id > 0 ? <option key={queue.id} value={queue.id}>{queue.id === 0 ? "Undefined" : queue.name}</option> : null;
                                                })
                                            }
                                        </Form.Control>
                                    </td>
                                    <td>
                                        <Form.Control as="select"
                                            value={event.eventPriorityId}
                                            className="borderless-control"
                                            name="eventPriorityId"
                                            key={i}
                                            id={"eventPriorityId" + i}
                                            size="sm"
                                            onChange={(e) => editSelectedEvent(i, "eventPriorityId", parseInt(e.target.value))}>
                                            {
                                                refData.eventPriorityRefData.map((priority) => {
                                                    return priority.id > 0 ? <option key={priority.id} value={priority.id}>{priority.id === 0 ? "Undefined" : priority.name}</option> : null;
                                                })
                                            }
                                        </Form.Control>
                                    </td>
                                    <td>{event.dueBy != null ? moment(event.dueBy).format('MM/DD/YYYY h:mm a') : 'Calculated on save'}</td>
                                    <td className={props.filters.showMyQueue ? "d-none" : ""}>
                                        <Form.Control as="select"
                                            value={event.assignedToId}
                                            className="borderless-control"
                                            name="assignedToId"
                                            key={i}
                                            id={"assignedToId" + i}
                                            size="sm"
                                            onChange={(e) => editSelectedEvent(i, "assignedToId", parseInt(e.target.value))}>
                                            <option value={0}>Unassigned</option>
                                            {
                                                refData.assignedToRefData.map((user) => {
                                                    return user.id > 0 ? <option key={user.id} value={user.id}>{user.name}</option> : null;
                                                })
                                            }
                                        </Form.Control>
                                    </td>
                                    <td>{event.statusName}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={closeModal}>Cancel</Button>
                <Button variant="success" onClick={saveEvents}>Save</Button>
            </Modal.Footer>
        </>
    );
};

export default BulkEditEventsModal